import React from "react";
import PropTypes from "prop-types";
import { Users } from "lucide-react";

const ReportField = ({ label, value }) => (
  <div className="flex flex-col border-b border-slate-100 pb-2 last:border-0 last:pb-0">
    <span className="text-[10px] text-slate-400 uppercase font-bold tracking-wider mb-1">
      {label}
    </span>
    <span className="text-sm font-medium text-slate-600">{value || "N/A"}</span>
  </div>
);

function RefereeInformationCard({ referees }) {
  if (!referees || referees.length === 0) {
    return (
      <div className="p-4 text-sm text-slate-500 text-center border border-dashed rounded-lg bg-white">
        No referee information available
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl  border border-slate-200 overflow-hidden w-full">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <Users size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Referee Information
        </h2>
      </div>

      <div className="p-6 space-y-8">
        {referees.map((referee, index) => (
          <div
            key={index}
            className="last:border-0 border-b border-slate-100 pb-6 last:pb-0"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
              {[
                {
                  label: "Full Name",
                  value: `${referee.first_name} ${referee.last_name}`,
                },
                { label: "Relationship", value: referee.relationship },
                { label: "Occupation", value: referee.occupation },
                { label: "Place of Work", value: referee.place_of_work },
                { label: "Phone Number", value: referee.phone_number },
                { label: "Home Address", value: referee.home_address },
              ].map((item, i) => (
                <ReportField key={i} label={item.label} value={item.value} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

RefereeInformationCard.propTypes = {
  referees: PropTypes.arrayOf(
    PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      relationship: PropTypes.string,
      occupation: PropTypes.string,
      place_of_work: PropTypes.string,
      phone_number: PropTypes.string,
      home_address: PropTypes.string,
    })
  ),
};

export default RefereeInformationCard;
